import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {Link} from "react-router-dom";
import {setPrevLocation} from "../../core/actions/appActions";
import Footer from "../../core/layout/footer/footer";
import CEOImg from "../../assets/img/about us/sandeepTendulkar.png";
import CTOImg from "../../assets/img/about us/abhayParab.png";
import "./aboutUs.css";

/* ─── Data ───────────────────────────────────── */
const team = [
    {
        img:  CEOImg,
        name: 'Sandeep Tendulkar',
        role: 'Founder & CEO',
        bio:  'Sandeep is an IT Specialist and business leader with 25+ years of experience across corporate and start-up environments. He has led global teams for financial services clients and built innovative technology solutions. He is passionate about democratizing technology for businesses and society.',
    },
    {
        img:  CTOImg,
        name: 'Abhay Parab',
        role: 'Partner & CTO',
        bio:  'Abhay is a technologist with 20+ years of experience across engineering, AI, big data, and cloud computing. He has worked with service providers, product companies, and startups, including leading Data Engineering at Tata Digital. He built the data platform and consumer view for the Tata Super App and has architected AI-powered analytics solutions like Cuddle.ai. At Fractal Analytics, he developed a big data integration platform for faster, automated insights. He is passionate about democratizing data, AI, and engineering to drive continuous innovation.',
    },
];

/* ─── Component ──────────────────────────────── */
function AboutUs() {

    useEffect(() => {
        window.scrollTo(0, 0);

        const io = new IntersectionObserver(entries => {
            entries.forEach(e => {
                if (e.isIntersecting) {
                    e.target.classList.add('visible');
                    io.unobserve(e.target);
                }
            });
        }, {threshold: 0.08});

        document.querySelectorAll('.au-fade-up').forEach(el => io.observe(el));
        return () => io.disconnect();
    }, []);

    /* ── Section 1: Hero ─────────────────────── */
    const renderHero = () => (
        <section className="au-hero">
            <div className="au-hero-inner">
                <div className="au-hero-layout">
                    {/* Left */}
                    <div className="au-hero-left">
                        <div className="au-eyebrow">About Us</div>
                        <h1 className="au-hero-heading">
                            Executive Team &amp;<br />
                            <span>Our Vision</span>
                        </h1>
                        <p className="au-hero-desc">
                            Meet the people behind DeccanLogic — senior technologists who have spent
                            decades building, scaling, and delivering enterprise-grade technology, now
                            working to make that expertise accessible to every business.
                        </p>
                    </div>
                    {/* Right: Vision card */}
                    <div className="au-vision-card">
                        <div className="au-vision-label">Vision</div>
                        <p className="au-vision-text">
                            To democratize enterprise quality technology services for the benefit of
                            broader society and businesses.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );

    /* ── Section 2: Executive Team ───────────── */
    const renderTeam = () => (
        <section className="au-team-section">
            <div className="au-wrap">
                <div className="au-fade-up">
                    <div className="au-section-tag">Leadership</div>
                    <h2 className="au-section-title">Executive <span>Team</span></h2>
                </div>
                <div className="au-team-list">
                    {team.map(({img, name, role, bio}, i) => (
                        <div key={name} className={`au-member-card au-fade-up${i === 1 ? ' d1' : ''}`}>
                            <div className="au-member-left">
                                <div className="au-avatar">
                                    <img src={img} alt={name} className="au-avatar-img" />
                                </div>
                                <div className="au-member-name">{name}</div>
                                <div className="au-member-role">{role}</div>
                            </div>
                            <p className="au-member-bio">{bio}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );

    /* ── Section 3: CTA Banner ───────────────── */
    const renderCTA = () => (
        <section className="au-cta-banner">
            <div className="au-cta-inner">
                <div className="au-fade-up">
                    <h2>Ready to Explore AI for Your Business?</h2>
                    <p>
                        Let's talk about the problem you're trying to solve. We'll tell you honestly
                        whether AI is the right tool — and if it is, how we'd build it.
                    </p>
                </div>
                <div className="au-cta-actions au-fade-up d2">
                    <Link to="/contact-us" className="dl-btn dl-btn-white">
                        <i className="fas fa-envelope"></i> info@deccanlogic.com
                    </Link>
                </div>
            </div>
        </section>
    );

    /* ── Render ──────────────────────────────── */
    return (
        <div className="w-100">
            {renderHero()}
            {renderTeam()}
            {renderCTA()}
            <Footer/>
        </div>
    );
}

const mapStateToProps = (state) => ({
    isMobileView:   state.appState.deviceInfo.isMobileView,
    isMobileDevice: state.appState.deviceInfo.isMobileDevice,
    isLGView:       state.appState.deviceInfo.isLGView,
    isMDView:       state.appState.deviceInfo.isMDView,
    isXLView:       state.appState.deviceInfo.isXLView,
    isXSView:       state.appState.deviceInfo.isXSView,
});

export default connect(mapStateToProps, {setPrevLocation})(withRouter(AboutUs));
